import { API_ROUTES } from "../../utils/constants";
import { AxiosBase } from "./index";

export default class BroadcastTemplateService extends AxiosBase {
  getAllTemplates = async ({ page, limit, name }) => {
    try {
      let url = `${API_ROUTES.BROADCAST.TEMPLATES}?page=${page}&limit=${limit}`
      if (name) {
        url += `&name=${name}`;
      }
      const response = await this.requests.get(url);
      return response;
    } catch (err) {
      if (err?.response?.status === 401) {
        throw err;
      }
      throw err;
    }
  };
  createTemplate = async (body) => {
    try {
      const response = await this.requests.post(
        `${API_ROUTES.BROADCAST.SEND_TEMPLATE}`,
        body
      );
      return response;
    } catch (err) {
      if (err?.response?.status === 401) {
        throw err;
      }
      throw err;
    }
  };
}


